import { apiErrorLogger, apiInfoLogger } from '@/lib/monitoring/api-logger';
import { useAuthenticatedQuery } from '@/hooks/auth/use-auth-query-hooks';
import { SubscriptionsApiService } from '@/services/internal-api/subscriptions/subscriptions-api-service';

const fetchPurchaseEventHealth = async (subscriptionId: string, timestamp: any) => {
  return await SubscriptionsApiService.queryPurchaseEventHealth(subscriptionId, timestamp);
};

export function usePurchaseEventHealth(subscriptionId: string, timestamp: any, config = {}) {
  return useAuthenticatedQuery(
    ['purchaseEventHealth', subscriptionId],
    () => fetchPurchaseEventHealth(subscriptionId, timestamp),
    {
      staleTime: 1000 * 60 * 5,
      retry: 3,
      refetchOnWindowFocus: false,
      enabled: !!subscriptionId,
      onSuccess: data => {
        apiInfoLogger('Purchase event health request successfully', 'useHealthQuery', data);
      },
      onError: error => {
        apiErrorLogger('Purchase event health request failed', 'useHealthQuery', error);
      },
      ...config,
    }
  );
}
